const SALE_STATUS_LABELS = {
  open: 'Abierta',
  suspended: 'Suspendida',
  completed: 'Completada',
  cancelled: 'Cancelada',
  conversion_blocked: 'Bloqueada',
};

const SALE_STATUS_BADGES = {
  open: 'bg-yellow-100 text-yellow-800',
  suspended: 'bg-orange-100 text-orange-800',
  completed: 'bg-green-100 text-green-700',
  cancelled: 'bg-red-100 text-red-700',
  conversion_blocked: 'bg-red-100 text-red-700',
};

export const getSaleStatusMeta = (status) => {
  if (!status) {
    return { label: 'Sin estado', badgeClassName: 'bg-gray-100 text-gray-600' };
  }
  const normalized = String(status).trim().toLowerCase();
  return {
    label: SALE_STATUS_LABELS[normalized] || status,
    badgeClassName: SALE_STATUS_BADGES[normalized] || 'bg-gray-100 text-gray-600',
  };
};

export { SALE_STATUS_LABELS, SALE_STATUS_BADGES };
